import moment from 'moment';
import { i18n } from 'vue-infra';
import { isNil } from 'lodash';

let overdueSign = '';
let majorTimeValue = '';
let majorTimeUnit = '';
let minorTimeValue = '';
let minorTimeUnit = '';

const minutesToDisplay = (seconds, minutes) => (seconds > 29 ? minutes + 1 : minutes);

const calcFormattedDuration = () => {
  const formattedDuration = {
    overdueSign: '',
    timeUnits: [],
  };

  formattedDuration.overdueSign = overdueSign;
  formattedDuration.timeUnits.push({ value: majorTimeValue, unit: majorTimeUnit });
  formattedDuration.timeUnits.push({ value: minorTimeValue, unit: minorTimeUnit });

  return formattedDuration;
};

export default (value, type, extendedLogic) => {
  if (isNil(value) || value === '') {
    return '';
  }
  const duration = moment.duration(value);

  const seconds = Math.abs(duration.seconds());
  const minutes = Math.abs(duration.minutes());
  const hours = Math.abs(duration.hours());
  const days = Math.abs(duration.days());
  const months = Math.abs(duration.months());
  const years = Math.abs(duration.years());
  const overdue = value < 0;

  if (type === 'long') {
    const overdueSignStr = overdue ? i18n.t('amd:time_overdue') : '';
    const yearsStr = years ? `${years} ${i18n.t('amd:time_unit_year_long')} ` : '';
    const monthsStr = months ? `${months} ${i18n.t('amd:time_unit_month_long')} ` : '';
    const daysStr = days ? `${days} ${i18n.t('amd:time_unit_day_long')} ` : '';
    const hoursStr = hours ? `${hours} ${i18n.t('amd:time_unit_hour_long')} ` : '';
    const minStr = minutes ? `${minutes} ${i18n.t('amd:time_unit_minute_long')} ` : '';
    const secStr = seconds ? `${seconds} ${i18n.t('amd:time_unit_second_long')} ` : '';

    return `${yearsStr}${monthsStr}${daysStr}${hoursStr}${minStr}${secStr}${overdueSignStr}`;
  }

  majorTimeValue = '';
  majorTimeUnit = '';
  minorTimeValue = '';
  minorTimeUnit = '';
  overdueSign = ((minutesToDisplay(seconds, minutes) > 0 || hours > 0 || days > 0) && overdue) ? '-' : '';

  if (years) {
    if (months) {
      majorTimeValue = years;
      majorTimeUnit = i18n.t('amd:time_unit_year_short');
      minorTimeValue = months;
      minorTimeUnit = i18n.t('amd:time_unit_month_short');
      return calcFormattedDuration();
    }
    majorTimeValue = years;
    majorTimeUnit = i18n.t('amd:time_unit_year_short');

    return calcFormattedDuration();
  }

  if (months) {
    if (days) {
      majorTimeValue = months;
      majorTimeUnit = i18n.t('amd:time_unit_month_short');
      minorTimeValue = days;
      minorTimeUnit = i18n.t('amd:time_unit_day_short');
      return calcFormattedDuration();
    }
    majorTimeValue = months;
    majorTimeUnit = i18n.t('amd:time_unit_month_short');
    return calcFormattedDuration();
  }

  if (days) {
    const hoursToDisplay = minutes >= 30 ? hours + 1 : hours;
    if (hoursToDisplay === 24) {
      majorTimeValue = days + 1;
      majorTimeUnit = i18n.t('amd:time_unit_day_short');
      return calcFormattedDuration();
    }
    if (hoursToDisplay) {
      majorTimeValue = days;
      majorTimeUnit = i18n.t('amd:time_unit_day_short');
      minorTimeValue = hoursToDisplay;
      minorTimeUnit = i18n.t('amd:time_unit_hour_short');
      return calcFormattedDuration();
    }
    majorTimeValue = days;
    majorTimeUnit = i18n.t('amd:time_unit_day_short');
    return calcFormattedDuration();
  }

  if (hours) {
    const currentMinutesToDisplay = minutesToDisplay(seconds, minutes);
    if (currentMinutesToDisplay === 0) {
      majorTimeValue = hours;
      majorTimeUnit = i18n.t('amd:time_unit_hour_short');
      return calcFormattedDuration();
    }
    if (currentMinutesToDisplay === 60) {
      if (hours === 23) {
        majorTimeValue = 1;
        majorTimeUnit = i18n.t('amd:time_unit_day_short');
        return calcFormattedDuration();
      }
      majorTimeValue = hours + 1;
      majorTimeUnit = i18n.t('amd:time_unit_hour_short');
      return calcFormattedDuration();
    }
    majorTimeValue = hours;
    majorTimeUnit = i18n.t('amd:time_unit_hour_short');
    minorTimeValue = currentMinutesToDisplay;
    minorTimeUnit = i18n.t('amd:time_unit_minute_short');
    return calcFormattedDuration();
  }

  if (minutes) {
    if (minutes === 59 && seconds > 30) {
      majorTimeValue = 1;
      majorTimeUnit = i18n.t('amd:time_unit_hour_short');
      return calcFormattedDuration();
    } else if (extendedLogic && minutes <= 5) {
      if (seconds < 15) {
        majorTimeValue = minutes;
        majorTimeUnit = i18n.t('amd:time_unit_minute_short');
        return calcFormattedDuration();
      } else if (seconds >= 15 && seconds <= 44) {
        majorTimeValue = minutes;
        majorTimeUnit = i18n.t('amd:time_unit_minute_short');
        minorTimeValue = 30;
        minorTimeUnit = i18n.t('amd:time_unit_second_short');
        return calcFormattedDuration();
      }
      majorTimeValue = minutes + 1;
      majorTimeUnit = i18n.t('amd:time_unit_minute_short');
      return calcFormattedDuration();
    }
    majorTimeValue = minutesToDisplay(seconds, minutes);
    majorTimeUnit = i18n.t('amd:time_unit_minute_short');
    return calcFormattedDuration();
  }
  majorTimeValue = seconds;
  majorTimeUnit = i18n.t('amd:time_unit_second_short');

  return calcFormattedDuration();
};
